import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  UpdateBrokerDetails,
  getCompanyApi,
} from "../../../Services/Superadmin/Superadmin";
import { getUserFromToken } from "../../../Utils/TokenVerify";

const TAB_STYLES = `
  .broker-tabs-wrapper {
    font-family: 'Segoe UI', sans-serif;
  }

  .broker-tab-nav {
    display: flex;
    gap: 0;
    border-bottom: 2px solid #e2e8f0;
    margin-bottom: 28px;
  }

  .broker-tab-btn {
    padding: 12px 24px;
    border: none;
    background: transparent;
    font-size: 14px;
    font-weight: 600;
    color: #94a3b8;
    cursor: pointer;
    position: relative;
    transition: color 0.2s;
    letter-spacing: 0.3px;
    border-bottom: 3px solid transparent;
    margin-bottom: -2px;
  }

  .broker-tab-btn:hover {
    color: #334155;
  }

  .broker-tab-btn.active {
    color: #2563eb;
    border-bottom: 3px solid #2563eb;
  }

  .broker-tab-btn .tab-icon {
    margin-right: 8px;
    font-size: 15px;
  }

  .tab-badge {
    display: inline-block;
    background: #dbeafe;
    color: #1d4ed8;
    font-size: 10px;
    padding: 2px 7px;
    border-radius: 20px;
    margin-left: 7px;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  .broker-tab-content {
    animation: fadeSlideIn 0.25s ease;
  }

  @keyframes fadeSlideIn {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .info-box {
    background: #f0f9ff;
    border: 1px solid #bae6fd;
    border-radius: 10px;
    padding: 12px 16px;
    margin-bottom: 20px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 13px;
    color: #0369a1;
  }

  .info-box i { margin-top: 2px; }

  .auto-time-card {
    background: linear-gradient(135deg, #1e40af 0%, #2563eb 100%);
    border-radius: 14px;
    padding: 20px 24px;
    color: white;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 4px 20px rgba(37,99,235,0.25);
  }

  .auto-time-card .time-display {
    font-size: 36px;
    font-weight: 800;
    letter-spacing: 1px;
    font-variant-numeric: tabular-nums;
  }

  .auto-time-card .time-label {
    font-size: 12px;
    opacity: 0.75;
    margin-top: 2px;
  }

  .auto-time-card .clock-icon {
    font-size: 48px;
    opacity: 0.2;
  }

  .schedule-badge {
    background: rgba(255,255,255,0.15);
    border: 1px solid rgba(255,255,255,0.3);
    border-radius: 8px;
    padding: 6px 14px;
    font-size: 13px;
    font-weight: 600;
    backdrop-filter: blur(4px);
  }

  .btn-update {
    background: #2563eb;
    border: none;
    color: white;
    padding: 10px 24px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.2s, transform 0.1s;
  }

  .btn-update:hover { background: #1d4ed8; }
  .btn-update:active { transform: scale(0.97); }

  .btn-connect {
    background: #059669;
    border: none;
    color: white;
    padding: 10px 24px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.2s, transform 0.1s;
  }

  .btn-connect:hover { background: #047857; }
  .btn-connect:active { transform: scale(0.97); }

  .section-divider {
    border: none;
    border-top: 1px solid #e2e8f0;
    margin: 20px 0;
  }
`;

const BrokerConnet = () => {
  const TokenData = getUserFromToken();
  const [activeTab, setActiveTab] = useState("manual");

  const [brokerDetails, setBrokerDetails] = useState({
    userid: "",
    password: "",
    totp_secret: "",
    api_key: "",
    api_secret: "",
    access_token: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showTotp, setShowTotp] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    getAllClientData();
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllClientData = async () => {
    try {
      const data = { userid: TokenData?.user_id };
      const response = await getCompanyApi(data);
      if (response.status) {
        const clientData = response.data;
        setBrokerDetails({
          userid: clientData.userid || "",
          password: clientData.password || "",
          totp_secret: clientData.totp_secret || "",
          access_token: clientData.access_token || "",
          api_key: clientData.api_key || "",
          api_secret: clientData.api_secret || "",
        });
      }
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };

  const handleBrokerChange = (e) => {
    const { name, value } = e.target;
    setBrokerDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdateBrokerDetails = async () => {
    try {
      const data = {
        userid: brokerDetails.userid,
        password: brokerDetails.password,
        totp_secret: brokerDetails.totp_secret,
        access_token: brokerDetails.access_token,
        api_key: brokerDetails.api_key,
        api_secret: brokerDetails.api_secret,
      };
      const response = await UpdateBrokerDetails(data);
      if (response?.status) {
        Swal.fire({
          icon: "success",
          title: "Broker Details Updated",
          text: "Broker credentials updated successfully.",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      } else throw new Error("Update failed");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "There was an error updating the broker details. Please try again.",
      });
    }
  };

  const HandelConnectBroker = async () => {
    try {
      window.open(
        "https://ant.aliceblueonline.com/?appcode=" + brokerDetails.api_key,
        "_blank",
      );
    } catch (error) {}
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString("en-IN", {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div className="container-fluid">
      <style>{TAB_STYLES}</style>

      <div className="card transaction-table custom-bg">
        <div className="row justify-content-center">
          <div className="col-lg-12 col-md-12">
            <div className="card shadow-sm border-0 rounded-4 broker-tabs-wrapper">
              {/* Header */}
              <div className="card-header border-0 rounded-top-4 px-4 py-3 d-flex justify-content-between align-items-center bg-light">
                <div className="d-flex align-items-center gap-2">
                  <i className="bi bi-plug-fill text-primary fs-5"></i>
                  <div>
                    <h5 className="mb-0 fw-semibold">Broker Connection</h5>
                    <small className="text-muted">Trading account status</small>
                  </div>
                </div>

                {brokerDetails?.access_token?.length > 15 ? (
                  <span className="badge bg-success-subtle text-success px-3 py-2">
                    <i className="bi bi-check-circle me-1"></i> Connected
                  </span>
                ) : (
                  <span className="badge bg-danger-subtle text-danger px-3 py-2">
                    <i className="bi bi-x-circle me-1"></i> Not Connected
                  </span>
                )}
              </div>
              <hr className="mt-0 mb-0" />

              {/* Tab Navigation */}
              <div className="px-4 pt-3">
                <div className="broker-tab-nav">
                  <button
                    className={`broker-tab-btn ${activeTab === "manual" ? "active" : ""}`}
                    onClick={() => setActiveTab("manual")}
                  >
                    <i className="fa fa-key tab-icon" />
                    Manual Login
                  </button>
                  <button
                    className={`broker-tab-btn ${activeTab === "redirect" ? "active" : ""}`}
                    onClick={() => setActiveTab("redirect")}
                  >
                    <i className="fa fa-external-link tab-icon" />
                    Redirect Login
                  </button>
                  <button
                    className={`broker-tab-btn ${activeTab === "auto" ? "active" : ""}`}
                    onClick={() => setActiveTab("auto")}
                  >
                    <i className="fa fa-clock-o tab-icon" />
                    Auto Login
                    <span className="tab-badge">AUTO</span>
                  </button>
                </div>
              </div>

              {/* Tab Content */}
              <div className="card-body px-4 pt-2 pb-4">
                {/* ─────── TAB 1: Manual Login ─────── */}
                {activeTab === "manual" && (
                  <div className="broker-tab-content">
                    <div className="info-box">
                      <i className="fa fa-info-circle" />
                      <span>
                        Manual login uses your <strong>User ID</strong> and a
                        pre-generated <strong>Access Token</strong>. Paste the
                        token directly from your broker dashboard.
                      </span>
                    </div>

                    <div className="mb-3">
                      <label className="form-label fw-semibold">User ID</label>
                      <input
                        type="text"
                        className="form-control"
                        name="userid"
                        value={brokerDetails.userid}
                        onChange={handleBrokerChange}
                        placeholder="Enter broker User ID"
                      />
                      <small className="text-muted">
                        Your broker-provided login ID.
                      </small>
                    </div>

                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Access Token
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="access_token"
                        value={brokerDetails.access_token}
                        onChange={handleBrokerChange}
                        placeholder="Paste your access token here"
                      />
                      <small className="text-muted">
                        Copy from your broker's API dashboard. Tokens usually
                        expire daily.
                      </small>
                    </div>

                    <hr className="section-divider" />
                    <div className="d-flex justify-content-end gap-2">
                      <button
                        className="btn-update"
                        onClick={handleUpdateBrokerDetails}
                      >
                        <i className="fa fa-save me-2" /> Update
                      </button>
                    </div>
                  </div>
                )}

                {/* ─────── TAB 2: Redirect Login ─────── */}
                {activeTab === "redirect" && (
                  <div className="broker-tab-content">
                    <div className="info-box">
                      <i className="fa fa-info-circle" />
                      <span>
                        Redirect login opens your broker's auth page. Enter your{" "}
                        <strong>API Key</strong> &amp; <strong>Secret</strong>,
                        then click <strong>Connect Broker</strong> to authorize.
                      </span>
                    </div>

                    <div className="mb-3">
                      <label className="form-label fw-semibold">User ID</label>
                      <input
                        type="text"
                        className="form-control"
                        name="userid"
                        value={brokerDetails.userid}
                        onChange={handleBrokerChange}
                        placeholder="Enter broker User ID"
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label fw-semibold">API Key</label>
                      <input
                        type="text"
                        className="form-control"
                        name="api_key"
                        value={brokerDetails.api_key}
                        onChange={handleBrokerChange}
                        placeholder="Enter API Key"
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        API Secret
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="api_secret"
                        value={brokerDetails.api_secret}
                        onChange={handleBrokerChange}
                        placeholder="Enter API Secret"
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        Redirect URL
                      </label>
                      <input
                        type="text"
                        className="form-control bg-light"
                        value={window.location.origin + "/backend/aliceblue"}
                        readOnly
                      />
                      <small className="text-muted">
                        Use this as the redirect URI in your broker's API
                        settings.
                      </small>
                    </div>

                    <hr className="section-divider" />
                    <div className="d-flex justify-content-end gap-2">
                      <button
                        className="btn-update"
                        onClick={handleUpdateBrokerDetails}
                      >
                        <i className="fa fa-save me-2" /> Update
                      </button>
                      <button
                        className="btn-connect"
                        onClick={HandelConnectBroker}
                      >
                        <i className="fa fa-plug me-2" /> Connect Broker
                      </button>
                    </div>
                  </div>
                )}

                {/* ─────── TAB 3: Auto Login ─────── */}
                {activeTab === "auto" && (
                  <div className="broker-tab-content">
                    {/* Live Clock Card */}
                    <div className="auto-time-card">
                      <div>
                        <div className="time-display">
                          {formatTime(currentTime)}
                        </div>
                        <div className="time-label">
                          {formatDate(currentTime)}
                        </div>
                        <div className="mt-2">
                          <span className="schedule-badge">
                            <i className="fa fa-bolt me-1" />
                            Auto Login scheduled at 8:20 AM
                          </span>
                        </div>
                      </div>
                      <i className="fa fa-clock-o clock-icon" />
                    </div>

                    <div className="info-box">
                      <i className="fa fa-info-circle" />
                      <span>
                        Auto Login will automatically sign in to your broker
                        every morning at <strong>8:20 AM</strong> using the
                        credentials saved below.
                      </span>
                    </div>

                    <div className="mb-3">
                      <label className="form-label fw-semibold">User ID</label>
                      <input
                        type="text"
                        className="form-control"
                        name="userid"
                        value={brokerDetails.userid}
                        onChange={handleBrokerChange}
                        placeholder="Enter broker User ID"
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label fw-semibold">Password</label>
                      <div className="input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          name="password"
                          value={brokerDetails.password}
                          onChange={handleBrokerChange}
                          placeholder="Enter broker password"
                        />
                        <button
                          type="button"
                          className="input-group-text btn btn-outline-secondary"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <i
                            className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                          />
                        </button>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        TOTP Secret
                      </label>
                      <div className="input-group">
                        <input
                          type={showTotp ? "text" : "password"}
                          className="form-control"
                          name="totp_secret"
                          value={brokerDetails.totp_secret}
                          onChange={handleBrokerChange}
                          placeholder="Enter TOTP secret"
                        />
                        <button
                          type="button"
                          className="input-group-text btn btn-outline-secondary"
                          onClick={() => setShowTotp(!showTotp)}
                        >
                          <i
                            className={`fa ${showTotp ? "fa-eye-slash" : "fa-eye"}`}
                          />
                        </button>
                      </div>
                      <div className="mb-3">
                      <label className="form-label fw-semibold">
                        API Secret
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="api_secret"
                        value={brokerDetails.api_secret}
                        onChange={handleBrokerChange}
                        placeholder="Enter API Secret"
                      />
                    </div>
                      <small className="text-muted">
                        Required for 2FA auto-login.
                      </small>
                    </div>

                    <div className="mb-3">
                      <label className="form-label fw-semibold">API Key</label>
                      <input
                        type="text"
                        className="form-control"
                        name="api_key"
                        value={brokerDetails.api_key}
                        onChange={handleBrokerChange}
                        placeholder="Enter API Key"
                      />
                    </div>

                    <hr className="section-divider" />
                    <div className="d-flex justify-content-end gap-2">
                      <button
                        className="btn-update"
                        onClick={handleUpdateBrokerDetails}
                      >
                        <i className="fa fa-save me-2" /> Update
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrokerConnet;
